import { Component } from '@angular/core';


@Component({
  selector: 'app-become-adonor',
  templateUrl: './become-adonor.component.html',
  styleUrls: ['./become-adonor.component.scss']
})
export class BecomeADonorComponent {

  openSameTab(ev: Event, href: string) {
    ev.preventDefault();                // evita navegação SPA
    window.location.assign(href);       // navega na mesma aba com reload
    // window.location.replace(href);   // se não quiser empilhar no histórico
  }
  
}
